import React from 'react';
import { IIcon } from './../../@types/icons';

export function CircleCheckbox ({ size = 16 }: IIcon) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 16 16"
    >
      <rect
        width="15"
        height="15"
        x="0.5"
        y="0.5"
        stroke="#919191"
        rx="7.5"
      />
    </svg>
  );
}
